/**
 * @generated SignedSource<<cd6ebe2ea97f1b1b441281487f8c42d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsComponent_Routine$data = {
  readonly activeSections: ReadonlyArray<{
    readonly assignedTeam: {
      readonly id: string;
    } | null;
    readonly id: string;
    readonly title: string | null;
  }>;
  readonly activeVersion: {
    readonly tasks: ReadonlyArray<{
      readonly __typename: string;
      readonly goals?: ReadonlyArray<{
        readonly greaterThan: number | null;
        readonly lessThan: number | null;
        readonly section: {
          readonly id: string;
        };
      }>;
      readonly id: string;
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "KPIEditSectionsComponent_Routine";
};
export type KPIEditSectionsComponent_Routine$key = {
  readonly " $data"?: KPIEditSectionsComponent_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponent_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIEditSectionsComponent_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "activeSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskNumberGoals",
                  "kind": "LinkedField",
                  "name": "goals",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "greaterThan",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lessThan",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoutineSection",
                      "kind": "LinkedField",
                      "name": "section",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "TaskNumber",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "0b59ee111b7b629c527a05f6fb28b3c4";

export default node;
